// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a0768072","667":"61aeaa4a","977":"f22cd142"}[chunkId] + ".chunk.js";
};